"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentfulProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ContentfulContext = require("./ContentfulContext");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import invariant from 'invariant';
var ContentfulProvider = function ContentfulProvider(_ref) {
  var accessToken = _ref.accessToken,
      children = _ref.children,
      _ref$componentMap = _ref.componentMap,
      componentMap = _ref$componentMap === void 0 ? {} : _ref$componentMap,
      _ref$environment = _ref.environment,
      environment = _ref$environment === void 0 ? 'master' : _ref$environment,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en-US' : _ref$locale,
      _ref$preview = _ref.preview,
      preview = _ref$preview === void 0 ? false : _ref$preview,
      space = _ref.space,
      _ref$queryMap = _ref.queryMap,
      queryMap = _ref$queryMap === void 0 ? {} : _ref$queryMap;
  (0, _react.useEffect)(function () {
    // invariant(accessToken, '`accessToken` props required on `ContentfulProvider`.');
    // invariant(space, '`space` required on `ContentfulProvider`.');
    if (!Object.keys(componentMap).length) {
      console.warn('`componentMap` supplied to `ContentfulProvider` is empty.');
    } // if (!Object.keys(queryMap).length) {
    //   console.warn('`queryMap` supplied to `ContentfulProvider` is empty.');
    // }

  }, [accessToken, componentMap, queryMap, space]);
  var value = (0, _react.useMemo)(function () {
    return {
      accessToken: accessToken,
      componentMap: componentMap,
      environment: environment,
      locale: locale,
      preview: preview,
      queryMap: queryMap,
      space: space
    };
  }, [accessToken, componentMap, environment, locale, preview, queryMap, space]);
  return /*#__PURE__*/_react.default.createElement(_ContentfulContext.ContentfulContext.Provider, {
    value: value
  }, children);
};

exports.ContentfulProvider = ContentfulProvider;